export interface Shape {
    cardBorderRadius: string;
}

export default {
    cardBorderRadius: '8px',
};
